import {Inject, Injectable} from '@angular/core';
import {FileRecordError, FileRecordObject, SessionSizeObject} from './file-record';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {firstValueFrom, of, retry, throwError, timer} from "rxjs";

@Injectable()
export class FileRecordService {
  constructor(@Inject(HttpClient) private readonly http: HttpClient) {
  }

  getSessionContentSize(): Promise<any> {
    let url = `/upload/file/sessionSize`;
    const getSessionContentSizeWithRetry$ = this.http.get(url, {}).pipe(
      retry({
        count: 10,
        delay: (error: HttpErrorResponse, retryCount: number)=> {
          switch (error.status) {
            case 401:
              return timer(400 * retryCount);
            default:
              return throwError(() => error)
          }
        },
      })
    );

    return firstValueFrom(getSessionContentSizeWithRetry$)
      .then(resp => resp)
      .catch(this.handleError);
  }

  getSessionTableContent(): Promise<FileRecordObject[]> {
    let url = `/upload/file/sessionTable`;
    const getSessionTableContentWithRetry$ = this.http.get(url, {}).pipe(
      retry({
        count: 10,
        delay: (error: HttpErrorResponse, retryCount: number)=> {
          switch (error.status) {
            case 401:
              return timer(400 * retryCount);
            default:
              return throwError(() => error)
          }
        },
      })
    );

    return firstValueFrom(getSessionTableContentWithRetry$).then(resp => resp).catch(this.handleError);
  }

  getHistoryTableContent(): Promise<FileRecordObject[]> {
    let url = `/upload/file/historyTable`;
    const getHistoryTableContentWithRetry$ = this.http.get(url, {}).pipe(
      retry({
        count: 10,
        delay: (error: HttpErrorResponse, retryCount: number)=> {
          switch (error.status) {
            case 401:
              return timer(400 * retryCount);
            default:
              return throwError(() => error)
          }
        },
      })
    );

    return firstValueFrom(getHistoryTableContentWithRetry$)
      .then(resp => resp)
      .catch(this.handleError);
  }

  getHistoryTableErrorContent(id: string): Promise<FileRecordError[]> {
    const url = `/upload/file/recordErrors/${id}`;
    const getHistoryTableErrorContentWithRetry$ = this.http.get(url, {}).pipe(
      retry({
        count: 10,
        delay: (error: HttpErrorResponse, retryCount: number)=> {
          switch (error.status) {
            case 401:
              return timer(400 * retryCount);
            default:
              return throwError(() => error)
          }
        },
      })
    );

    return firstValueFrom(getHistoryTableErrorContentWithRetry$)
      .then(resp => resp)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  toFileRecordObjectList(jsonFileRecordList: any): FileRecordObject[] {
    let fileRecordObjectList:FileRecordObject[] = new Array<FileRecordObject>();
    for (let jsonFileRecord of jsonFileRecordList) {
      fileRecordObjectList.push(jsonFileRecord);
    }
    return fileRecordObjectList;
  }
}
